module.exports = __webpack_public_path__ + "img/13.d8d45fef.jpg";